import { css } from '..'
import futuraBold from '../fonts/futura-std-bold.woff'
import futuraRegular from '../fonts/futura-std-book.woff'

export const fontFaces = css`
  @font-face {
    font-family: 'Futura';
    src: url(${futuraBold}) format('woff');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'Futura';
    src: url(${futuraRegular}) format('woff');
    font-weight: normal;
    font-style: normal;
  }
`
